import { rangeStep } from '@moda/portal-stanchions';
import { PageFilterFacetFragment } from '../../generated/types';

const MIN = 40;
const MAX = 80;
const TEN = 10;
const ONE_HUNDRED = 100;

export const getSaleTagItems = (
  saleTags: (PageFilterFacetFragment | null)[],
  saleTagParams: string[]
) => {
  if (!saleTags) return null;

  const counts = rangeStep(TEN, ONE_HUNDRED + 1, TEN).reduce(
    (counts, key) => ({
      ...counts,
      [key]: (
        saleTags.find(tag => tag && Number(tag.name) === key) || {
          totalItems: 0
        }
      ).totalItems
    }),
    {} as { [key: string]: number }
  );

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  const cumulatedCounts = rangeStep(ONE_HUNDRED, 1, -10).reduce(
    (cumulatedCounts, key) => ({
      ...cumulatedCounts,
      [key]: (cumulatedCounts[key + TEN] || 0) + counts[key]
    }),
    {} as { [key: string]: number }
  );

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  const lastTag = rangeStep(MAX, 1, -10).find(key => cumulatedCounts[key] >= TEN);

  if (!lastTag || MIN >= lastTag) return undefined;

  const tags = rangeStep(MIN, lastTag + 1, TEN).filter(key =>
    saleTags.find(tag => tag && Number(tag.name) === key)
  );

  if (tags.length < 2) return undefined;

  return [
    {
      key: 'all',
      label: 'All Sale',
      value: [] as string[],
      isSelected: saleTagParams.length === 0
    },
    ...tags.map((key, index) => {
      const value =
        index === tags.length - 1
          ? saleTags.filter(tag => tag && Number(tag.name) >= key).map(tag => tag && tag.name)
          : [String(key)];

      return {
        key,
        label: `${key - TEN}%${index === tags.length - 1 ? '+' : ''} Off`,
        value,
        isSelected: value.every(key => key && saleTagParams.includes(key))
      };
    })
  ].filter(Boolean);
};
